import { createSelector } from 'reselect';
import WorkspaceMeetingModeConstants from 'Shared/constants/WorkspaceMeetingMode.constants';

const getWorkspaceMeetingModeItems = state => state.workspaceMeetingMode;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getWorkspaceSlugParam = createParameterSelector(params => params.workspaceSlug);

export const getMeetingModeSessions = createSelector([getWorkspaceMeetingModeItems], meetingModes => {
  return meetingModes.get(WorkspaceMeetingModeConstants.State.WORKSPACE_MEETING_MODES_BY_WORKSPACE_ID);
});

export const getMeetingModeDismissedPopoverList = createSelector([getWorkspaceMeetingModeItems], meetingModes => {
  return meetingModes.get(WorkspaceMeetingModeConstants.State.DISMISSED_PARTICIPANT_POPOVER_MEET_MODE_ID);
});

export const getAllActiveMeetingModes = createSelector([getMeetingModeSessions], meetingModes => {
  return meetingModes.filter(session => session.get(WorkspaceMeetingModeConstants.Model.ACTIVE) === true);
});

export const getWorkspaceMeetingModeItemByWorkspaceSlug = createSelector(
  [getAllActiveMeetingModes, getWorkspaceSlugParam],
  (meetingModes, workspaceSlug) => {
    return meetingModes.get(workspaceSlug);
  }
);

export const getBotByWorkspaceId = (state, { workspaceId }) => {
  const bots = state.workspaceMeetingMode?.get?.(WorkspaceMeetingModeConstants.State.WORKSPACE_BOTS);
  return bots?.get?.(workspaceId)?.toJS?.();
};
